import { concat } from '@ember/helper';
import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';
import cssVars from 'volta/modifiers/css-vars';

import type { TOC } from '@ember/component/template-only';

interface BvSkeletonSignature {
  Args: {
    delay?: `${number}ms`;
    variation?: 'sm' | 'xs' | 'tab';
    width?: number;
  };
  Element: HTMLDivElement;
}

const BvSkeletonComponent: TOC<BvSkeletonSignature> = <template>
  <div
    class={{classNames
      'bv-skeleton bv-animation-pulsate'
      (if @variation (concat 'bv-skeleton--' @variation))
    }}
    {{cssVars
      bv-skeleton-delay=(orElse @delay 0)
      bv-skeleton-width=(if @width (concat @width 'px') '100%')
    }}
    ...attributes
  ></div>
</template>;

export default BvSkeletonComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvSkeleton: typeof BvSkeletonComponent;
    'bv-skeleton': typeof BvSkeletonComponent;
  }
}
